import React, { useState } from "react";
import "../css/LoginScreen.css";
import { FaGoogle, FaApple } from "react-icons/fa";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDatabase, set, onValue, push, ref } from "firebase/database";
import { doSignInWithEmailAndPassword } from "../config/auth";
import { setUserInfo } from "../localStorage";
import LoaderComponent from "../component/LoaderComponent";

const LoginScreen = () => {
	const navigate = useNavigate();
	const [showPassword, setShowPassword] = useState(false);
	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});
	const [loading, setLoading] = useState(false);
	const [loader, setLoader] = useState(false);
	const [error, setError] = useState("");
	const [resetMessage, setResetMessage] = useState("");

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setResetMessage("");
		setLoading(true);
		setLoader(true);
		try {
			const result = await doSignInWithEmailAndPassword(
				formData.email,
				formData.password,
			)
				.then((userCredential) => {
					toast.success("Login successfull...!");
					const uid = userCredential.user.uid;
					const db = getDatabase();
					const userRef = ref(db, "users/" + uid);
					onValue(userRef, (snapshot) => {
						const data = snapshot.val();
						setTimeout(() => {
							setUserInfo(data);
							navigate("/");
						}, 500);
						setLoading(false);
						setLoader(false);
					});
				})
				.catch((error) => {
					console.log("SIGNIN_ERR", error.code);
					toast.error("Please provide correct credential!");
					setLoading(false);
					setLoader(false);
				});
		} catch (err) {
			console.error("Login error:", err);
			setLoader(false);
			if (err.code === "auth/user-not-found") {
				setError("No account found with this email");
			} else if (err.code === "auth/invalid-credential") {
				setError("Incorrect email or password");
			} else if (err.code === "auth/invalid-email") {
				setError("Invalid email address");
			} else {
				setError("Something went wrong. Please try again.");
			}
		} finally {
			setLoading(false);
			setLoader(false);
		}
	};

	return (
		<div className="container">
			{loader ? <LoaderComponent /> : ""}
			<div className="row d-flex justify-content-center">
				<div className="login-card">
					<h2 className="login-title">Welcome Back 👋</h2>
					<p className="login-subtitle py-4">
						Please login to your account
					</p>

					{resetMessage && (
						<p className="success-text">{resetMessage}</p>
					)}

					<form className="login-form" onSubmit={handleSubmit}>
						<div className="input-group">
							<input
								type="email"
								name="email"
								value={formData.email}
								onChange={handleChange}
								required
							/>
							<label>Email Address</label>
						</div>

						<div className="input-group password-group">
							<input
								type={showPassword ? "text" : "password"}
								name="password"
								value={formData.password}
								onChange={handleChange}
								required
							/>
							<label>Password</label>

							<span
								className="password-toggle"
								onClick={() => setShowPassword(!showPassword)}
							>
								<i
									className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
								/>
							</span>
						</div>

						{error && <p className="login-error">{error}</p>}

						<button
							type="submit"
							className="login-btn"
							disabled={loading}
						>
							{loading ? "Logging in..." : "Login"}
						</button>

						<div className="text-center py-3">
							<Link className="forgot-text" to="/forgotpassword">
								Forgot Password ?
							</Link>
						</div>

						<div className="divider">
							<span>OR</span>
						</div>

						{/* <button
						type="button"
						className="social-btn google-btn"
						onClick={handleGoogleLogin}
					>
						<FaGoogle className="icon" />
						Continue with Google
					</button> */}

						{/* <button
						type="button"
						className="social-btn apple-btn"
						disabled
					>
						<FaApple className="icon" />
						Continue with Apple
					</button> */}

						<p className="register-text">
							Don’t have an account ?
							<NavLink
								to="/register"
								className="register-link pl-2"
							>
								Register
							</NavLink>
						</p>
					</form>
				</div>
			</div>
		</div>
	);
};

export default LoginScreen;
